import { useEffect, useState } from 'react';
import { getSubscriberInfo, hasSubscribed } from '../utils/subscriber-storage';

const EVENT_NAME = 'nrwh_subscriber_updated';

/**
 * Returns the current subscriber status and listens for updates.
 * When markSubscribed() is called anywhere on the page, this hook
 * triggers a re-render so all forms recognize the new subscriber.
 */
export function useSubscriberStatus() {
  const [, forceUpdate] = useState(0);

  useEffect(() => {
    const handler = () => forceUpdate((n) => n + 1);
    window.addEventListener(EVENT_NAME, handler);
    return () => window.removeEventListener(EVENT_NAME, handler);
  }, []);

  return {
    hasSubscribed: hasSubscribed(),
    subscriberInfo: getSubscriberInfo(),
  };
}
